import { PortalRequest as request } from "@/utils/request";

/**
 * 首页供应商lucene搜索
 * @param params
 * @param data
 * @returns {AxiosPromise}
 */
export const luceneSearchIsv = (params, data) => {
    return request({
        url: "/product/luceneSearchIsv",
        method: "post",
        params: params,
        data,
    });
};


/**
 * 首页解决方案lucene搜索
 * @param params
 * @param data
 * @returns {AxiosPromise}
 */
export const luceneSearchSolution = (params, data) => {
    return request({
        url: "/product/luceneSearchSolution",
        method: "post",
        params: params,
        data,
    });
};

/**
 * 首页Iot产品lucene搜索
 * @param params
 * @param data
 * @returns {AxiosPromise}
 */
export const luceneSearchIot = (params, data) => {
    return request({
        url: "/product/luceneSearchIot",
        method: "post",
        params: params,
        data,
    });
};

/**
 * 首页知识汇聚lucene搜索
 * @param params
 * @param data
 * @returns {AxiosPromise}
 */
export const luceneSearchKnow = (params, data) => {
    return request({
        url: "/knowledge/luceneSearchKnowledgeGather",
        method: "post",
        params: params,
        data,
    });
};

/**
 *
 * @returns {AxiosPromise}
 * @param text
 */
export const luceneSearchCount = (text) => {
    return request({
        url: "/dat/lucene/search-count",
        method: "get",
        params: {text},
    });
};
